import { Context, createContext, useContext, useReducer } from 'react';

interface IGalleryContext {
  isDragging: boolean;
  magnificationFactor: number;
  setIsDragging: (isGrabbing: boolean) => void;
}

const INITIAL_STATE: IGalleryContext = {
  isDragging: false,
  magnificationFactor: 40,
  setIsDragging: () => {},
};

const GalleryContext: Context<IGalleryContext> = createContext({} as IGalleryContext);

const Actions = {
  SET_IS_DRAGGING: 'SET_IS_GRABBING',
};

function galleryReducer(state: IGalleryContext, action: any) {
  switch (action.type) {
    case Actions.SET_IS_DRAGGING: {
      return { ...state, isDragging: action.payload };
    }
    default:
      return state;
  }
}

interface IGalleryContextProviderProps {
  children: React.ReactNode;
  magnificationFactor: number;
}

export const GalleryContextProvider = ({
  children,
  magnificationFactor,
}: IGalleryContextProviderProps) => {
  const [state, dispatch] = useReducer(galleryReducer, INITIAL_STATE);

  const setIsDragging = (isGrabbing: boolean) => {
    dispatch({ type: Actions.SET_IS_DRAGGING, payload: isGrabbing });
  };

  return (
    <GalleryContext.Provider
      value={{
        isDragging: state.isDragging,
        magnificationFactor,
        setIsDragging,
      }}
    >
      {children}
    </GalleryContext.Provider>
  );
};

export function useGalleryContext() {
  const contextData = useContext(GalleryContext);
  return contextData;
}
